export type AppMigrationOneLinkTouchpoint = 'topBanner' | 'bottomSheet' | 'plp' | 'pdp';

export interface IAppMigrationAppsFlyerLink {
  campaignName?: string;
  shortLink?: string;
}

export type IAppMigrationAppsFlyerLinks = Partial<
  Record<AppMigrationOneLinkTouchpoint, IAppMigrationAppsFlyerLink>
>;

/**
 * Resolve AppsFlyer OneLink short URL from remote config for a touchpoint.
 * Returns empty string when missing — callers should no-op or use store fallback.
 */
export const getAppMigrationOneLinkUrl = (
  links: IAppMigrationAppsFlyerLinks | undefined | null,
  touchpoint: AppMigrationOneLinkTouchpoint
): string => {
  const shortLink = links?.[touchpoint]?.shortLink;
  return typeof shortLink === 'string' ? shortLink.trim() : '';
};
